import { API } from "@aws-amplify/api";
import { API_NAME } from "../constants";

function validToken(centerId, aadhar) {
  let path = "/validtoken/" + centerId + "/" + aadhar;
  return API.get(API_NAME, path);
}

export default validToken;
